import * as React from 'react';

import styles from './styles.module.scss';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	checked: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	label?: string;
	labelClassName?: string;
	id: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
	checked,
	onChange,
	label,
	labelClassName,
	id,
}) => {

	return (
		<div className={styles['checkbox-container']}>
			<div className={styles['select-checkbox']}>
				<input
					checked={checked}
					id={id}
					onChange={onChange}
					readOnly={!onChange}
					type="checkbox"
				/>
			</div>
			{
				label &&
				<label className={labelClassName} htmlFor={id} >{label}</label>
			}
		</div>
	);
};

export default React.memo(Checkbox);
